var exports = {
  "k": "x31de4314--845193--container",
  "i": "x31de4314--845193--wrapper",
};

module.exports = exports;
